import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { ActionButtonComponent, ButtonAction, ButtonType } from '../action-button';
import { MaterialModule } from '../../material.module';
import { ConfirmationDialogAfterClosedModel, ConfirmationDialogDataModel } from './models/confirmation-dialog.model';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'ui-confirmation-dialog',
  imports: [ActionButtonComponent, MaterialModule, TranslateModule],
  templateUrl: './confirmation-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmationDialogComponent {
  confirmed$ = new BehaviorSubject<ConfirmationDialogAfterClosedModel>(null);
  cancelled$ = new BehaviorSubject<ConfirmationDialogAfterClosedModel>(null);
  buttonAction = ButtonAction;
  buttonType = ButtonType;
  comment = '';
  commentLength = 0;
  readonly commentMaxLength = 300;

  constructor(
    public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public dialogData: ConfirmationDialogDataModel,
  ) {}

  onCommentInput(event: Event): void {
    this.comment = (event.target as HTMLTextAreaElement).value;
    this.commentLength = this.comment.length;
  }

  confirm(): void {
    this.confirmed$.next({
      dialogRef: this.dialogRef,
      comment: this.comment,
    });
  }

  closeDialog(): void {
    this.cancelled$.next({
      dialogRef: this.dialogRef,
    });
    this.dialogRef.close();
  }
}
